import { useState, useEffect } from 'react';
import { useFirebase } from 'components/Firebase/index.js';

export const useIdToken = () => {
  const [idToken, setIdToken] = useState(null);
  const firebase = useFirebase();

  useEffect(() => {
    return firebase.onAuthUserListener(() => {
      firebase.auth.currentUser.getIdToken().then(setIdToken);
    }, () => {
      setIdToken(null);
    });
  }, [firebase]);

  return idToken;
};

export default useIdToken;
